import React from 'react';

export default function BulletedItem({
  as: Component = 'li',
  marker,
  children,
  className = '',
  markerClassName = ''
}) {
  return (
    <Component className={`flex items-start ${className}`}>
      {marker && (
        <span className={`shrink-0 ${markerClassName}`} aria-hidden="true">
          {marker}
        </span>
      )}
      <div className="flex-1">{children}</div>
    </Component>
  );
}
